<div class="container-fluid mb-3 mt-18 breadcrumb-wrap" *ngIf="breadcrumbs.length && show">
    <a routerLink="dashboard"><i class="fa fa-home"></i></a>
    <ng-container *ngFor="let item of breadcrumbs; last as last">
        <i class="fa fa-angle-right"></i>
        <a [routerLink]="item.url" *ngIf="!last && item.clickable !== false">{{ item.text | titlecase }}</a>
        <span *ngIf="last || item.clickable === false">{{ item.text | titlecase }}</span>
    </ng-container>
</div>